module.exports = __webpack_public_path__ + "img/202509-2_12.b3e41ffe.jpg";